import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

/**
 * Ogni immagine passa da opacity 0.2 a 1 man mano che entra nella vista,
 * poi resta a 1. Con `scrub` l'opacità è legata alla posizione di
 * scroll: 0.2 quando l'immagine inizia a comparire (top al bordo basso
 * dello scroller), 1 quando è completamente entrata (bottom al bordo
 * basso). Le immagini già visibili al caricamento partono direttamente
 * a 1, perché ScrollTrigger calcola lo stato iniziale in base alla
 * posizione corrente.
 *
 * Punto chiave: su desktop lo scroll avviene DENTRO
 * .cappelli-story-gallery__list (overflow-y: auto), non sulla pagina.
 * Quindi lì lo `scroller` di ScrollTrigger è il box; sotto il breakpoint
 * lo scroll è quello della pagina (scroller di default).
 *
 * @param {HTMLElement} el Wrapper .cappelli-story-gallery
 */
function initStoryGallery(el) {
  const list = el.querySelector(".cappelli-story-gallery__list");
  const imgs = el.querySelectorAll(".cappelli-story-gallery__img");

  if (!list || imgs.length === 0) {
    return;
  }

  if (prefersReducedMotion) {
    gsap.set(imgs, { opacity: 1 });
    return;
  }

  const buildTriggers = (scroller) => () => {
    imgs.forEach((img) => {
      gsap.fromTo(
        img,
        { opacity: 0.2 },
        {
          opacity: 1,
          ease: "none",
          scrollTrigger: {
            scroller, // box interno (desktop) o null = pagina (mobile)
            trigger: img,
            start: "top bottom",
            end: "bottom bottom",
            scrub: true,
          },
        },
      );
    });
  };

  const mm = gsap.matchMedia();

  // Desktop: scroll dentro il box. 782px = subito sopra il breakpoint
  // mobile di WordPress (781px), coerente con il CSS.
  mm.add("(min-width: 782px)", buildTriggers(list));

  // Mobile: scroll con la pagina.
  mm.add("(max-width: 781px)", buildTriggers(null));
}

document.querySelectorAll(".cappelli-story-gallery").forEach(initStoryGallery);

// Le altezze reali delle immagini possono variare dopo il caricamento:
// ricalcolo le posizioni dei trigger a load completato.
window.addEventListener("load", () => {
  ScrollTrigger.refresh();
});
